import {
  PROD_SUPERVISOR_PEOPLE_PATHS,
  PROD_SUPERVISOR_UTILITY_PATHS,
} from './prodSupervisorRouteAllowlist'

/** Rutas de People Management visibles para RRHH sin roles fuera de HR. */
export const HR_LABOR_MODULE_PATHS = new Set([...PROD_SUPERVISOR_PEOPLE_PATHS])

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isHrLaborPathAllowed(pathname) {
  const path = (pathname || '/').split('?')[0] || '/'
  if (PROD_SUPERVISOR_UTILITY_PATHS.has(path)) return true
  if (HR_LABOR_MODULE_PATHS.has(path)) return true
  return false
}
